// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-footer {
  justify-content: unset;
  display: block;
}

.delete-button {
  cursor: pointer;
  line-height: 33px;
  color: #29BB73;
  font-size: 12px;
}

.location-type-dropdown .dropdown-toggle .arrow {
  line-height: 35px;
  position: absolute;
  right: 0.5rem;
  font-size: 14px;
  color: #5e0066;
  margin-right: 9px;
  margin-left: auto;
}

.bg-blue {
  color: white;
  background-color: #085FFF;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/add-location/add-location.component.scss","webpack://./src/styles/global/_colors.scss"],"names":[],"mappings":"AACA;EACI,sBAAA;EACA,cAAA;AAAJ;;AASA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AANJ;;AAWI;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AARN;;AAaA;EACE,YAAA;EACA,yBC9BgB;ADoBlB","sourcesContent":["@import '../../../../styles/global/colors';\n.modal-footer {\n    justify-content: unset;\n    display: block;\n}\n\n// .delete-button {\n//     cursor: pointer;\n//     position: relative;\n//     top:calc(50% - 10px);\n// }\n\n.delete-button {\n    cursor: pointer;\n    line-height: 33px;\n    color: #29BB73;\n    font-size: 12px;\n}\n\n.location-type-dropdown {\n  .dropdown-toggle {\n    .arrow {\n      line-height: 35px;\n      position: absolute;\n      right: .5rem;\n      font-size: 14px;\n      color: #5e0066;\n      margin-right: 9px;\n      margin-left: auto;\n    }\n  }\n}\n\n.bg-blue {\n  color: white;\n  background-color: $interviews-blue;\n}","$interviews-light-gray: #E0E0E0;\n$interviews-alt-light-gray: #ECECEC;\n$interviews-table-gray: #F5F5F5;\n$interviews-dark-gray: #262624;\n$interviews-gray: #585857;\n$interviews-blue: #085FFF;\n$interviews-scroll-blue: #b4ceff;\n$interviews-pink: #FF7FDE; \n$interviews-btn-submitted: #FADDB3;\n$interviews-btn-submitted-outline: #ED8E00;\n$interviews-btn-approved: #DAF2B7;\n$interviews-btn-approved-outline: #83D510;\n$interviews-btn-rejected: #FBCCD2;\n$interviews-btn-rejected-outline: #ED001C;\n$interviews-btn-draft: rgb(148, 148, 141);\n$interviews-btn-draft-outline: rgb(57, 57, 57);"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
